/* tslint:disable */
/* eslint-disable */
/**
 * EVIMO API
 * Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PartnerMaintenanceTimerRequestDto
 */
export interface PartnerMaintenanceTimerRequestDto {
    /**
     * 
     * @type {string}
     * @memberof PartnerMaintenanceTimerRequestDto
     */
    kind: PartnerMaintenanceTimerRequestDtoKindEnum;
    /**
     * 
     * @type {string}
     * @memberof PartnerMaintenanceTimerRequestDto
     */
    clockStart?: PartnerMaintenanceTimerRequestDtoClockStartEnum | null;
    /**
     * 
     * @type {string}
     * @memberof PartnerMaintenanceTimerRequestDto
     */
    calendarMode?: PartnerMaintenanceTimerRequestDtoCalendarModeEnum | null;
}


/**
 * @export
 */
export const PartnerMaintenanceTimerRequestDtoKindEnum = {
    TakeCharge: 'TAKE_CHARGE',
    Intervention: 'INTERVENTION',
    Resolution: 'RESOLUTION'
} as const;
export type PartnerMaintenanceTimerRequestDtoKindEnum = typeof PartnerMaintenanceTimerRequestDtoKindEnum[keyof typeof PartnerMaintenanceTimerRequestDtoKindEnum];

/**
 * @export
 */
export const PartnerMaintenanceTimerRequestDtoClockStartEnum = {
    IncidentDetected: 'INCIDENT_DETECTED',
    FaultReported: 'FAULT_REPORTED',
    TicketCreated: 'TICKET_CREATED',
    TicketTakenInCharge: 'TICKET_TAKEN_IN_CHARGE',
    FirstIntervention: 'FIRST_INTERVENTION'
} as const;
export type PartnerMaintenanceTimerRequestDtoClockStartEnum = typeof PartnerMaintenanceTimerRequestDtoClockStartEnum[keyof typeof PartnerMaintenanceTimerRequestDtoClockStartEnum];

/**
 * @export
 */
export const PartnerMaintenanceTimerRequestDtoCalendarModeEnum = {
    Continuous247: 'CONTINUOUS_24_7',
    ExcludingWeekendsAndHolidays: 'EXCLUDING_WEEKENDS_AND_HOLIDAYS',
    BusinessHours: 'BUSINESS_HOURS'
} as const;
export type PartnerMaintenanceTimerRequestDtoCalendarModeEnum = typeof PartnerMaintenanceTimerRequestDtoCalendarModeEnum[keyof typeof PartnerMaintenanceTimerRequestDtoCalendarModeEnum];


/**
 * Check if a given object implements the PartnerMaintenanceTimerRequestDto interface.
 */
export function instanceOfPartnerMaintenanceTimerRequestDto(value: object): value is PartnerMaintenanceTimerRequestDto {
    if (!('kind' in value) || value['kind'] === undefined) return false;
    return true;
}

export function PartnerMaintenanceTimerRequestDtoFromJSON(json: any): PartnerMaintenanceTimerRequestDto {
    return PartnerMaintenanceTimerRequestDtoFromJSONTyped(json, false);
}

export function PartnerMaintenanceTimerRequestDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): PartnerMaintenanceTimerRequestDto {
    if (json == null) {
        return json;
    }
    return {
        
        'kind': json['kind'],
        'clockStart': json['clockStart'] == null ? undefined : json['clockStart'],
        'calendarMode': json['calendarMode'] == null ? undefined : json['calendarMode'],
    };
}

export function PartnerMaintenanceTimerRequestDtoToJSON(json: any): PartnerMaintenanceTimerRequestDto {
    return PartnerMaintenanceTimerRequestDtoToJSONTyped(json, false);
}

export function PartnerMaintenanceTimerRequestDtoToJSONTyped(value?: PartnerMaintenanceTimerRequestDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'kind': value['kind'],
        'clockStart': value['clockStart'],
        'calendarMode': value['calendarMode'],
    };
}

